module.exports = __webpack_public_path__ + "static/media/5e92fedc333832466f3dd829_Logo.175b16cb.svg";